import { ReactNode } from 'react';

/** セレクトボックスのオプション型 */
export type SelectOption<T = string> = {
  /** オプションの値 */
  value: T;
  /** オプションの表示ラベル */
  label: string;
};

type Props<T = string> = {
  /** オプションのリスト */
  options: SelectOption<T>[];
  /** 選択時のハンドラー */
  onChange: (value: React.ChangeEvent<HTMLSelectElement>) => void;
  /** 現在選択されている値 */
  selected: T;
  /** カスタムクラス名 */
  className?: string;
  /** カスタムアイコン */
  icon?: ReactNode;
  /** 幅のスタイル */
  width?: string;
};

/** 汎用的なSelectコンポーネント */
export const Select = <T extends string | number>({
  options,
  onChange,
  selected,
  className = '',
  icon,
  width = 'w-[200px]',
}: Props<T>) => {
  const baseClasses = `block w-full appearance-none bg-white border border-textPrimary rounded-md py-[12px] pl-[16px] pr-[40px] text-16px text-textPrimary focus:outline-none overflow-hidden whitespace-nowrap overflow-ellipsis`;

  return (
    <div className={`relative ${width}`}>
      <select
        className={`${baseClasses} ${className}`}
        onChange={onChange}
        value={selected}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
        {icon || <ChevronDownIcon />}
      </div>
    </div>
  );
};

const ChevronDownIcon = () => {
  return (
    <svg
      className="text-primary size-7"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};
